<template>
  <section class="deal">
    <TheTitle titleClass="pb-3">
      <img src="@/assets/img/statistics/deal.svg" alt="deal" class="mr-1" />成交數據
    </TheTitle>
    <template v-if="isUfun">
      <section class="mb-3">
        <h2>已兌換總數</h2>
        <LineChart
          :data="totalNumberOfRedemption"
          v-if="totalNumberOfRedemption"
          :x-field-date-format="inputVal.redemption"
          class="html2pdf__page-break"
        >
          <template v-slot:top-right>
            <DropDown
              v-model="inputVal.redemption"
              :options="dateFilterOptions"
              style="display: inline-block;"
              class="mr-1"
            ></DropDown>
          </template>
        </LineChart>
      </section>
    </template>
    <template v-else>
      <template v-if="user.class === 'PREMIUM' || role === 'admin' || role === 'sale'">
        <section class="mb-3">
          <h2>總銷售額</h2>
          <LineChart
            :data="totalSales"
            v-if="totalSales"
            :x-field-date-format="inputVal.sales"
            class="html2pdf__page-break"
            prepend-yaxis="$"
          >
            <template v-slot:top-right>
              <DropDown
                v-model="inputVal.sales"
                :options="dateFilterOptions"
                style="display: inline-block;"
                class="mr-1"
              ></DropDown>
            </template>
          </LineChart>
        </section>
        <section class="mb-3">
          <h2>成交訂單總數</h2>
          <LineChart
            :data="totalCompletedOrder"
            v-if="totalCompletedOrder"
            :x-field-date-format="inputVal.completedOrder"
            class="html2pdf__page-break"
          >
            <template v-slot:top-right>
              <DropDown
                v-model="inputVal.completedOrder"
                :options="dateFilterOptions"
                style="display: inline-block;"
                class="mr-1"
              ></DropDown>
            </template>
          </LineChart>
        </section>
        <section class="mb-3">
          <h2>
            總利潤<AGCLabel>
              <template v:slot:sub-label>
                <span style="color: #174169;">*已扣除平台費</span>
              </template>
            </AGCLabel>
          </h2>
          <LineChart
            :data="totalProfit"
            v-if="totalProfit"
            :x-field-date-format="inputVal.profit"
            class="html2pdf__page-break"
            prepend-yaxis="$"
          >
            <template v-slot:top-right>
              <DropDown
                v-model="inputVal.profit"
                :options="dateFilterOptions"
                style="display: inline-block;"
                class="mr-1"
              ></DropDown>
            </template>
          </LineChart>
        </section>
      </template>
    </template>
    <section class="mb-3">
      <h2>已使用優惠券總數</h2>
      <LineChart
        :data="totalNumberOfUsedCoupon"
        v-if="totalNumberOfUsedCoupon"
        :x-field-date-format="inputVal.usedCoupon"
        class="html2pdf__page-break"
      >
        <template v-slot:top-right>
          <DropDown
            v-model="inputVal.usedCoupon"
            :options="dateFilterOptions"
            style="display: inline-block;"
            class="mr-1"
          ></DropDown>
        </template>
      </LineChart>
    </section>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { scheduled, asyncScheduler } from 'rxjs';
import {
  tap, map, switchMap, debounceTime, pluck, mergeAll, filter,
} from 'rxjs/operators';
import AGCLabel from '@/components/form/AGCLabel.vue';
import DropDown from '@/components/DropDown.vue';
import store, { SET_LOADING } from '@/store';
import TheTitle from '@/components/TheTitle.vue';
import LineChart from '@/components/chart/LineChart.vue';
import dataTableMixin from '@/mixins/data-table';
import vModelMixin from '../../mixins/v-model';

export default {
  name: 'Deal',
  mixins: [dataTableMixin, vModelMixin],
  components: {
    AGCLabel,
    DropDown,
    TheTitle,
    LineChart,
  },
  props: ['dateRange', 'filter', 'keyword'],
  data: () => ({
    dateFilterOptions: [
      { value: 'week', text: '週' },
      { value: 'month', text: '月' },
      { value: 'year', text: '年' },
    ],
    interval: {
      redemption: 'week',
      usedCoupon: 'week',
      sales: 'week',
      profit: 'week',
      completedOrder: 'week',
    },
  }),
  methods: {},
  computed: {
    ...mapGetters(['role']),
    ...mapState(['user']),
    isUfun() {
      return this.filter?.paymentType === 'UFUN';
    },
    onPaymentTypeUpdate$() {
      return this.$watchAsObservable('filter.paymentType', { deep: true });
    },
    onIntervalRedemptionUpdate$() {
      return this.$watchAsObservable('inputVal.redemption');
    },
    onIntervalSalesUpdate$() {
      return this.$watchAsObservable('inputVal.sales');
    },
    onIntervalProfitUpdate$() {
      return this.$watchAsObservable('inputVal.profit');
    },
    onIntervalUsedCouponUpdate$() {
      return this.$watchAsObservable('inputVal.usedCoupon');
    },
    onIntervalCompletedOrderUpdate$() {
      return this.$watchAsObservable('inputVal.completedOrder');
    },
  },
  subscriptions() {
    const getTotalNumberOfRedemption$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/statistic/totalNumberOfRedemption`,
      },
      data,
    );
    const getTotalSales$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/statistic/totalSales`,
      },
      data,
    );
    const getTotalProfit$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/statistic/totalProfit`,
      },
      data,
    );
    const getTotalNumberOfUsedCoupon$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/statistic/totalNumberOfUsedCoupon`,
      },
      data,
    );
    const getTotalNumberOfCompletedOrder$ = (data) => this.httpRequest$(
      {
        method: 'GET',
        url: `/agc-${this.role}-api/statistic/totalNumberOfCompletedOrder`,
      },
      data,
    );

    return {
      totalNumberOfRedemption: scheduled(
        [...this.scheduleTasks, this.onPaymentTypeUpdate$, this.onIntervalRedemptionUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        filter(() => this.isUfun),
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
            interval: this.inputVal.redemption,
          },
        })),
        pluck('data'),
        switchMap(getTotalNumberOfRedemption$),
        map((totalNumberOfRedemption) => totalNumberOfRedemption.map((data) => ({
          date: new Date(data.date),
          value: data.value,
        }))),
      ),
      totalNumberOfUsedCoupon: scheduled(
        [...this.scheduleTasks, this.onPaymentTypeUpdate$, this.onIntervalUsedCouponUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
            interval: this.inputVal.usedCoupon,
          },
        })),
        pluck('data'),
        switchMap(getTotalNumberOfUsedCoupon$),
        map((totalNumberOfUsedCoupon) => totalNumberOfUsedCoupon.map((data) => ({
          date: new Date(data.date),
          value: data.value,
        }))),
      ),
      totalSales: scheduled(
        [...this.scheduleTasks, this.onPaymentTypeUpdate$, this.onIntervalSalesUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        filter(() => !this.isUfun),
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
            interval: this.inputVal.sales,
          },
        })),
        pluck('data'),
        switchMap(getTotalSales$),
        map((totalSales) => totalSales.map((data) => ({
          date: new Date(data.date),
          value: data.value,
        }))),
      ),
      totalProfit: scheduled(
        [...this.scheduleTasks, this.onPaymentTypeUpdate$, this.onIntervalProfitUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        filter(() => !this.isUfun),
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
            interval: this.inputVal.profit,
          },
        })),
        pluck('data'),
        switchMap(getTotalProfit$),
        map((totalProfit) => totalProfit.map((data) => ({
          date: new Date(data.date),
          value: data.value,
        }))),
      ),
      totalCompletedOrder: scheduled(
        [...this.scheduleTasks, this.onPaymentTypeUpdate$, this.onIntervalCompletedOrderUpdate$],
        asyncScheduler,
      ).pipe(
        mergeAll(),
        filter(() => !this.isUfun),
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        debounceTime(250),
        map(() => ({
          data: {
            ...this.filter,
            q: this.keyword,
            interval: this.inputVal.completedOrder,
          },
        })),
        pluck('data'),
        switchMap(getTotalNumberOfCompletedOrder$),
        map((totalCompletedOrder) => totalCompletedOrder.map((data) => ({
          date: new Date(data.date),
          value: data.value,
        }))),
      ),
    };
  },
};
</script>
<style></style>;
